import BaseBehavior from '../../foundation/base/base';

/* global CookieInformation */
/* global CookieConsent */

const COOKIE_CATEGORIES = [
	'cookie_cat_marketing',
	'cookie_cat_functional',
	'cookie_cat_statistic'
];

const consentGiven = category => CookieInformation.getConsentGivenFor(category);

class IFrame extends BaseBehavior {
	constructor(element) {
		super(element);

		this.element = element;
		this.initDomCache();

		this.iframe = this.dom.iframe;
		this.block = this.dom.block;
		this.button = this.dom.renew;

		this.addEventListener();
	}

	addEventListener() {
		if (CookieInformation) {
			window.addEventListener('CookieInformationConsentGiven', () => {
				this.checkCookieAccept();
			});
		}

		this.checkCookieAccept();

		this.button.addEventListener('click', () => {
			if (CookieConsent) {
				CookieConsent.renew();
			}
		});
	}

	checkCookieAccept() {
		const allAccepted = COOKIE_CATEGORIES.every(consentGiven);

		if (allAccepted) {
			this.loadIframe();
		} else {
			this.unloadIframe();
		}
	}

	loadIframe() {
		this.iframe.src = this.iframe.dataset.src;
		this.block.style.display = 'none';
	}

	unloadIframe() {
		this.iframe.src = '';
		this.block.style.display = 'inherit';
	}
}

export default IFrame;
